import {deleteDoc} from 'firebase/firestore';
import getProgressDocRef from './getProgressDocRef';

export default async function deleteProgressDoc(uid: string, examModuleId: string): Promise<void> {
  const ref = getProgressDocRef(uid, examModuleId);
  await deleteDoc(ref);
}
